module.exports = __webpack_public_path__ + "img/error.9bf4b416.svg";